import { triggerEventListener } from '../global/eventBus';

/**
 * Handles modal functionality.
 * 
 * This works by adding an event listener to an element trigger [data-modal-open-trigger] and assigning 
 * [data-modal-open-triggered] to the body element. If a close button or the modalUnderlay are clicked, the body property
 * will be reset, and hence hiding the modal.
 */
const initModal = (): void => {
  const closeModalTriggers = document.querySelectorAll('[data-modal-close-trigger]');
  const openModalTriggers: NodeListOf<HTMLDivElement> = document.querySelectorAll('[data-modal-open-trigger]');

  // Close modal events
  closeModalTriggers.forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      if (trigger !== e.target) { return false; }

      const body = document.querySelector('body');

      // Trigger a modal closed event
      triggerEventListener('modalclose', { 'modal': body.dataset.modalTriggered });

      // Dismiss modal
      body.dataset.modalTriggered = '';
      return true;
    });
  })

  // Open modal events
  openModalTriggers.forEach(trigger => {
    trigger.addEventListener('click', () => {
      const modalToTrigger = trigger.dataset.modalOpenTrigger;
      const body = document.querySelector('body');
      body.dataset.modalTriggered = modalToTrigger;

      // Trigger a modal closed event
      triggerEventListener('modalopen', { 'modal': modalToTrigger });
    });
  });
};

export default initModal;